import {
    Box,
    Button,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Yourinvestment from '../Cards/Yourinvestment';
import { getUserFromLocalStorage } from '../../../utils/utils';
import Axios from '../../../config/axios';
import { UrlConstant } from '../../../commom/UrlConstant';
import { useNavigate } from 'react-router-dom';
import img from '../../../style/images/referfriendbg.png';
import gif from '../../../style/Gif/confetti2.gif';
import wolfpackLogo from "../../../commom/Assets/images/LogoNew.png";
import Skeleton from 'react-loading-skeleton';
import { createTheme, ThemeProvider } from '@mui/material';
import Confirmpopup from './Confirmpopup';
import CashoutCard from '../MainComponents/CashOut/CashoutCard';
import ReferCard from '../MainComponents/ReferCard';
import { fetchAvailableAssets } from '../../../Redux/cashout/cashoutThunks';
import { KYC_STATUS, KycStatusValue } from './OnboardingStatusBar';
import KycOnboardingPopup from '../Popups/KycOnboardingPopup';
import { useAppDispatch, useAppSelector } from '../../../Redux/hooks';
import SpinPopup from '../Popups/SpinPopup';
import DepositBonusPopup from '../Popups/DepositBonusPopup';

const darkTheme = createTheme({
    palette: { mode: 'dark' },
    components: {
        MuiSkeleton: {
            styleOverrides: {
                root: { backgroundColor: '#2A2A2A' },
                pulse: { '&::after': { background: 'linear-gradient(90deg, #2A2A2A, #3C3C3C)' } },
            },
        },
    },
});

interface SpinNotification {
    id: string;
    type: string;
    spinCount: number;
    message: string;
    createdAt: string;
}

interface DepositTier {
    minAmount: number;
    spinCount: number;
}

interface DepositBonus {
    depositSpins: boolean;
    withinWindow: boolean;
    tiers: DepositTier[];
    windowEndsAt?: string;
    hoursRemaining?: number;
    hasDeposited?: boolean;
    message?: string;
    dismissed?: boolean;
}

interface KycStatusResponse {
    status: KycStatusValue;
    message: string;
    canCreateAccount: boolean;
    canUpdateDetails: boolean;
    currentStep?: number;
    isLinkBankAvailable?: boolean;
    isAus?: boolean;
    boosterLoanOptIn?: boolean;
    isOnbordingFlowCompleted?: boolean;
    isOnboardingFlowCompleted?: boolean;
    hasUnseenSpin?: boolean;
    spinNotifications?: {
        notifications: SpinNotification[];
        hasUnseen: boolean;
    };
    depositBonus?: DepositBonus;
}

const FUND_STEPS = ['Wolfpack Account', 'Trading Account', 'Start Investing Deposit', 'Booster Signup'];

type Accent = 'default' | 'error';

const ACCENT_COLORS: Record<Accent, string> = {
    default: '#F2674A',
    error: '#FF4D4D',
};

function CheckIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
                d="M5 13l4 4L19 7"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function CircularStepProgress({ percent, accentColor }: { percent: number; accentColor: string }) {
    const size = 110;
    const strokeWidth = 8;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (Math.min(Math.max(percent, 0), 100) / 100) * circumference;

    return (
        <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center" minWidth={size} minHeight={size}>
            <svg width={size} height={size}>
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="#3A3B44" strokeWidth={strokeWidth} fill="none" />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={percent >= 100 ? '#4EDF6D' : accentColor}
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                />
            </svg>
            <Box position="absolute" textAlign="center">
                <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '22px', lineHeight: 1 }}>
                    {Math.round(percent)}%
                </Typography>
                <Typography sx={{ color: '#9A9CA5', fontSize: '11px', mt: '4px' }}>
                    Complete
                </Typography>
            </Box>
        </Box>
    );
}

function FundStepsRow({ activeIndex, accentColor }: { activeIndex: number; accentColor: string }) {
    return (
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" width="100%" mt={3}>
            {FUND_STEPS.map((label, idx) => {
                const isDone = idx < activeIndex;
                const isActive = idx === activeIndex;
                const color = isDone ? '#4EDF6D' : isActive ? accentColor : '#3A3B44';
                const filled = isDone || isActive;

                return (
                    <React.Fragment key={label}>
                        <Box display="flex" flexDirection="column" alignItems="center" flex={1} minWidth={0}>
                            <Box
                                sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    backgroundColor: filled ? color : 'transparent',
                                    border: filled ? 'none' : `2px solid ${color}`,
                                    transition: 'background-color 0.2s, border-color 0.2s',
                                }}
                            >
                                {filled && <CheckIcon />}
                            </Box>
                            <Typography
                                sx={{
                                    color: 'white',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    mt: 1,
                                    lineHeight: 1.3,
                                    px: '2px',
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                        {idx < FUND_STEPS.length - 1 && (
                            <Box
                                sx={{
                                    height: '2px',
                                    flex: 1,
                                    mt: '16px',
                                    mx: '4px',
                                    backgroundColor: idx < activeIndex ? '#4EDF6D' : '#3A3B44',
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </Box>
    );
}

interface FlowCardProps {
    activeIndex: number;
    title: string;
    description: string;
    ctaLabel?: string;
    onCtaClick?: () => void;
    badgeLabel?: string;
    accent?: Accent;
    footer?: React.ReactNode;
}

function FlowStepsCard({
    activeIndex,
    title,
    description,
    ctaLabel,
    onCtaClick,
    badgeLabel,
    accent = 'default',
    footer,
}: FlowCardProps) {
    const accentColor = ACCENT_COLORS[accent];
    const percent = (activeIndex / FUND_STEPS.length) * 100;

    return (
        <Box
            width="440px"
            height="580px"
            borderRadius="30px"
            sx={{
                background: 'linear-gradient(180deg, #23242C 0%, #17181D 100%)',
                border: '1px solid rgba(255,255,255,0.06)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                padding: '32px 28px',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box display="flex" justifyContent="center" mb={7}>
                <img src={wolfpackLogo} alt="Wolfpack" style={{ height: '28px', width: 'auto' }} />
            </Box>

            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '22px', mb: 3, textAlign: 'center' }}>
                {title}
            </Typography>

            <Box display="flex" alignItems="center" gap="20px">
                <CircularStepProgress percent={percent} accentColor={accentColor} />
                <Typography sx={{ color: '#B0B3B8', fontSize: '15px', lineHeight: 1.5, whiteSpace: 'pre-line' }}>
                    {description}
                </Typography>
            </Box>

            <FundStepsRow activeIndex={activeIndex} accentColor={accentColor} />

            {footer && <Box mt={2}>{footer}</Box>}

            <Box mt="auto">
                {ctaLabel && onCtaClick ? (
                    <Button
                        variant="contained"
                        fullWidth
                        sx={{
                            backgroundColor: accentColor,
                            '&:hover': { backgroundColor: accentColor, filter: 'brightness(0.9)' },
                            borderRadius: '50px',
                            py: '12px',
                            fontSize: '16px',
                            fontWeight: 700,
                            textTransform: 'none',
                        }}
                        onClick={onCtaClick}
                    >
                        {ctaLabel}
                    </Button>
                ) : badgeLabel ? (
                    <Box
                        sx={{
                            textAlign: 'center',
                            color: accentColor,
                            border: `1px solid ${accentColor}`,
                            borderRadius: '50px',
                            py: '10px',
                            fontSize: '14px',
                            fontWeight: 700,
                        }}
                    >
                        {badgeLabel}
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
}

const RightSideSection: React.FC = () => {
    const user = getUserFromLocalStorage();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [kycStatus, setKycStatus] = useState<string | null>(null);
    const [kycMessage, setKycMessage] = useState<string>('');
    const [canCreateAccount, setCanCreateAccount] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showEConsentPopup, setShowEConsentPopup] = useState(false);
    const [popup, setPopup] = useState(false);
    const [showKycOnboardingPopup, setShowKycOnboardingPopup] = useState(false);
    const [showSpinPopup, setShowSpinPopup] = useState(false);
    const [canLinkBank, setCanLinkBank] = useState<any>(false);
    const [isAus, setIsAus] = useState<any>(false);
    const [showDepositBonusPopup, setShowDepositBonusPopup] = useState(false);
    const [depositBonus, setDepositBonus] = useState<DepositBonus | null>(null);

    const [isOnboardingFlowCompleted, setIsOnboardingFlowCompleted] = useState<boolean>(false);
    const [boosterLoanOptIn, setBoosterLoanOptIn] = useState<boolean>(false);

    const { metadata, loading } = useAppSelector((state) => state.cashout);

    useEffect(() => {
        dispatch(fetchAvailableAssets());
    }, [dispatch]);

    const fetchKYCStatus = async () => {
        try {
            setLoading(true);
            const response = await Axios.get(UrlConstant.Sumsub.CheckAccountStatus);
            if (response.data?.success) {
                const data = (response.data.data ?? {}) as KycStatusResponse;

                setKycStatus(data.status);
                setKycMessage(data.message ?? '');
                setCanCreateAccount(data.canCreateAccount === true);
                setCanLinkBank(data.isLinkBankAvailable === true);
                setIsAus(data.isAus === true);
                setIsOnboardingFlowCompleted(
                    data.isOnbordingFlowCompleted === true || data.isOnboardingFlowCompleted === true
                );
                setBoosterLoanOptIn(data.boosterLoanOptIn === true);
                setDepositBonus(data.depositBonus ?? null);

                if (data.depositBonus?.depositSpins) {
                    setShowDepositBonusPopup(true);
                } if (data.hasUnseenSpin) {
                    setShowSpinPopup(true);
                }

                setPopup(true);
            }
        } catch (error) {
            console.error('KYC status fetch error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchKYCStatus();
    }, []);

    const handleCreateAccount = () => {
        if (!user?.econsentAccepted) {
            setShowEConsentPopup(true);
        } else {
            setShowKycOnboardingPopup(true);
        }
    };

    const handleClearSpinFlag = async () => {
        setShowSpinPopup(false);
        try {
            await Axios.post(UrlConstant.User.updateSpinPopupStatus);
        } catch (error) {
            console.error('Failed to clear spin flag:', error);
        }
    };

    const handleFundNow = async () => {
        setShowDepositBonusPopup(false);
        try {
            await Axios.post(UrlConstant.User.updateDepositBonusPopupStatus);
        } catch (error) {
            console.error('Failed to clear deposit bonus flag:', error);
        }
        navigate('/transfer', { state: { canLinkBank, isAus } });
    };

    const handleCloseDepositBonusPopup = async () => {
        setShowDepositBonusPopup(false);
        try {
            await Axios.post(UrlConstant.User.updateDepositBonusPopupStatus);
        } catch (error) {
            console.error('Failed to clear deposit bonus flag:', error);
        }
    };

    const handleSpinNow = async () => {
        await handleClearSpinFlag();
        navigate('/referfriend');
    };

    const handleRegisterBoosterLoan = () => {
        navigate('/boosterlending');
    };

    const getActiveIndex = (): number => {
        if (!isOnboardingFlowCompleted) return 1;
        return boosterLoanOptIn ? 2 : 3;
    };

    const getFlowCardProps = (): Omit<FlowCardProps, 'activeIndex'> | null => {
        switch (kycStatus) {
            case KYC_STATUS.NOT_STARTED:
                return {
                    title: "Don't have a Wolfpack Trading Account?",
                    description: kycMessage || "Let's simplify your trading experience — verify your identity to set up your trading account.",
                    ctaLabel: 'Create Account',
                    onCtaClick: handleCreateAccount,
                };

            case KYC_STATUS.DOCUMENTS_PENDING:
                return {
                    title: 'Complete Your Application',
                    description: kycMessage || 'Finish submitting your documents to move forward.',
                    ctaLabel: 'Continue Application',
                    onCtaClick: handleCreateAccount,
                };

            case KYC_STATUS.PENDING:
                return {
                    title: 'Application Under Review',
                    description: kycMessage || "We're reviewing your details. This typically takes 1–2 business days.",
                    badgeLabel: 'Under Review',
                };

            case KYC_STATUS.ACTION_REQUIRED:
                return {
                    title: 'Action Required',
                    description: kycMessage || 'Resubmission requested. Please review and update your details.',
                    ctaLabel: canCreateAccount ? 'Continue Application' : undefined,
                    onCtaClick: canCreateAccount ? handleCreateAccount : undefined,
                    accent: 'error',
                };

            case KYC_STATUS.ON_HOLD:
                return {
                    title: 'Application On Hold',
                    description: kycMessage || 'Your application is on hold and being reviewed. No action required.',
                    badgeLabel: 'On Hold',
                };

            case KYC_STATUS.REJECTED:
                return {
                    title: 'Application Rejected',
                    description: kycMessage || 'Your application was rejected. Please contact support for assistance.',
                    accent: 'error',
                    badgeLabel: 'Rejected',
                    footer: (
                        <Typography variant="body2" textAlign="center" sx={{ color: '#B0B3B8' }}>
                            Contact us at{' '}
                            <a href="mailto:support@wolfpack.com" style={{ color: '#4A90E2' }}>
                                support@wolfpack.com
                            </a>
                        </Typography>
                    ),
                };

            case KYC_STATUS.AWAITING_BANK_LINK:
                return {
                    title: 'KYC Approved!',
                    description: kycMessage || 'Link your bank account to continue setting up your trading account.',
                    ctaLabel: 'Link Bank Account',
                    onCtaClick: () => navigate('/linkbankaccount'),
                };

            case KYC_STATUS.BANK_LINK_PENDING:
                return {
                    title: "We're Linking Your Bank Account…",
                    description: kycMessage || 'This usually only takes a moment — check back shortly for an update.',
                    ctaLabel: 'Check Status',
                    onCtaClick: () => navigate('/linkbankaccount'),
                };

            case KYC_STATUS.AWAITING_DEPOSIT:
                if (!boosterLoanOptIn) {
                    return {
                        title: 'One Step Away From Boosting Your Power!',
                        description: kycMessage || 'Register for Booster Loan to unlock more investing power for your trades.',
                        ctaLabel: 'Register Booster Loan',
                        onCtaClick: handleRegisterBoosterLoan,
                    };
                }
                return {
                    title: 'Fund Your Trading Account!',
                    description: kycMessage || 'Deposit Funds into Your Trading Account & Start Trading Now!',
                    ctaLabel: 'Deposit Funds',
                    onCtaClick: () => navigate('/transfer', { state: { canLinkBank, isAus } }),
                };

            default:
                return null;
        }
    };

    const renderRightSideContent = () => {
        if (kycStatus === KYC_STATUS.COMPLETED) {
            return <Yourinvestment onboardType="crypto" />;
        }

        const flowCardProps = getFlowCardProps();
        if (!flowCardProps) return null;

        return <FlowStepsCard activeIndex={getActiveIndex()} {...flowCardProps} />;
    };

    return (
        <>
            <Box height="100%">
                <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
                    <Typography component="h1" fontSize={24} className="text-white fs-24-desktop" mb={2}>
                        Your Investment
                    </Typography>
                </Box>

                <Box width="100%">
                    {isLoading ? (
                        <ThemeProvider theme={darkTheme}>
                            <Box className="card" height="633px" width="440px">
                                <Skeleton width="300px" height="30px" />
                            </Box>
                        </ThemeProvider>
                    ) : (
                        <Box height="580px" width="440px">
                            {renderRightSideContent()}
                        </Box>
                    )}
                </Box>

                <CashoutCard amount={metadata?.totalEligibleCashout} loading={loading} />
                <ReferCard open={popup} loading={loading} backgroundImage={img} gif={gif} />
            </Box>

            {showEConsentPopup && (
                <Confirmpopup
                    open={showEConsentPopup}
                    onClose={() => setShowEConsentPopup(false)}
                    onConfirm={() => {
                        setShowEConsentPopup(false);
                        navigate('/e-consent');
                    }}
                    message="You need to accept e-consent before proceeding with account creation."
                />
            )}
            {showKycOnboardingPopup && (
                <KycOnboardingPopup
                    open={showKycOnboardingPopup}
                    onClose={() => setShowKycOnboardingPopup(false)}
                    source="Dashboard_RightSideSection"
                />
            )}
            {showSpinPopup && (
                <SpinPopup
                    open={showSpinPopup}
                    onClose={handleClearSpinFlag}
                    onSpinNow={handleSpinNow}
                    spinCount={1}
                />
                
            )}
            {showDepositBonusPopup && depositBonus && (
                <DepositBonusPopup
                    open={showDepositBonusPopup}
                    onClose={handleCloseDepositBonusPopup}
                    onFundNow={handleFundNow}
                    tiers={depositBonus.tiers}
                    hoursRemaining={depositBonus.hoursRemaining}
                />
            )}
        </>
    );
};

export default RightSideSection;